import * as ReactDOMClient from 'react-dom/client';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var componentSelector = "script.epic-vite-component";
var EpicVite = /** @class */ (function () {
    function EpicVite() {
        this.startupReady = false;
        this.componentMap = new Map();
        this.renderedComponents = [];
        this.setupStartup();
    }
    /** Registers a component. */
    EpicVite.prototype.register = function (componentName, render) {
        this.componentMap.set(componentName, function () { return render; });
    };
    /** Registers a lazy loaded component. */
    EpicVite.prototype.registerDynamic = function (componentName, render) {
        this.componentMap.set(componentName, render);
    };
    /** Detects EpicVite placeholders and tries to render components into them. */
    EpicVite.prototype.renderComponents = function () {
        var _this = this;
        document.querySelectorAll(componentSelector).forEach(function (script) { return _this.renderComponent(script); });
    };
    /** Manually renders a component into element with specified ID. */
    EpicVite.prototype.render = function (componentName, root, context, hydrate) {
        return __awaiter(this, void 0, void 0, function () {
            var componentRender, component, render, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        componentRender = this.componentMap.get(componentName);
                        if (!componentRender) {
                            throw new Error("unknown component ".concat(componentName));
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, componentRender()];
                    case 2:
                        render = _a.sent();
                        component = render(context);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        throw new Error("error resolving component ".concat(componentName, ": ").concat(e_1));
                    case 4:
                        try {
                            if (hydrate) {
                                this.log("Hydrating ".concat(componentName));
                                ReactDOMClient.hydrateRoot(root, component);
                            }
                            else {
                                this.log("Rendering ".concat(componentName));
                                ReactDOMClient.createRoot(root).render(component);
                            }
                            this.renderedComponents.push(root);
                        }
                        catch (e) {
                            throw new Error("rendering ".concat(componentName, " failed: ").concat(e));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    EpicVite.prototype.setupStartup = function () {
        var _this = this;
        if (this.startupReady || globalThis.document === undefined || globalThis.setTimeout === undefined) {
            return;
        }
        this.startupReady = true;
        if (document.readyState !== "loading") {
            window.setTimeout(function () { return _this.renderComponents(); });
        }
        else {
            document.addEventListener("DOMContentLoaded", function () { return _this.renderComponents(); });
        }
    };
    EpicVite.prototype.renderComponent = function (script) {
        return __awaiter(this, void 0, void 0, function () {
            var domId, root, ssr, componentName, context, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        domId = script.dataset.domId;
                        if (!domId) {
                            this.error("dom ID missing");
                            return [2 /*return*/];
                        }
                        root = document.querySelector("#".concat(domId));
                        if (!root) {
                            this.error("cannot find root element with ID ".concat(domId));
                            return [2 /*return*/];
                        }
                        // We already rendered this component
                        if (this.renderedComponents.includes(root)) {
                            return [2 /*return*/];
                        }
                        ssr = !!script.dataset.ssr;
                        componentName = script.dataset.componentName;
                        if (!componentName) {
                            this.error("component name missing");
                            return [2 /*return*/];
                        }
                        try {
                            context = JSON.parse(script.textContent || "{}");
                        }
                        catch (e) {
                            return [2 /*return*/, this.error("cannot parse context for ".concat(domId, ": "), e)];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.render(componentName, root, context, ssr)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        return [2 /*return*/, this.error(e_2)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    EpicVite.prototype.log = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        console.info.apply(console, __spreadArray(["[EpicVite]: "], msg, false));
    };
    EpicVite.prototype.error = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        console.error.apply(console, __spreadArray(["[EpicVite]: "], msg, false));
    };
    return EpicVite;
}());
var instance = new EpicVite();

export { instance as default };
